import { ContainerDisplayStyle as ContainerDisplayStyleEnum } from '@/services/graphQL/api/generated/types_web';

export const ContainerDisplayStyle = {
  ...ContainerDisplayStyleEnum,
  PROMO: 'PROMO',
  SUBNAV: 'SUBNAV',
  FEATUREDROW: 'FEATURED_ROW',
} as const;

export type ContainerDisplayStyle =
  (typeof ContainerDisplayStyle)[keyof typeof ContainerDisplayStyle];
